import { Stack, Table, TableActiveColumnFilters, TableHeader, TableProvider, useTableState } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { GroupMember } from '@mews-commander/data-access';
import { useUserGroupMembersQuery } from '../../queries/useUserGroupMembersQuery';
import { useColumns } from './tableMapping';

export const UsersDetails = ({ groupId }: { groupId: string }) => {
    const columns = useColumns();

    const [tableState, setTableState] = useTableState<GroupMember>({
        pagination: {
            pageSize: 25,
        },
    });

    const { data, isFetching } = useUserGroupMembersQuery(groupId, tableState);
    const totalRowCount = data?.totalRowCount || 0;

    return (
        <Stack vertical spacing="200">
            <TableProvider state={tableState} onStateChange={setTableState} columns={columns}>
                <TableHeader
                    title={<LocalizedText textKey={TextKey.UserPlural} />}
                    subTitle={totalRowCount}
                    globalSearch={{ placeholder: <LocalizedText textKey={TextKey.Search} /> }}
                />

                <TableActiveColumnFilters />

                <Table
                    uniqueRowId="id"
                    data={data?.data || []}
                    amountOfRows={totalRowCount}
                    loading={isFetching}
                    fixedFirstColumn
                />
            </TableProvider>
        </Stack>
    );
};
